var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-row mt-2"},[_c('div',{staticClass:"user-bubble"},[_c('div',{staticClass:"message-content"},[_vm._v(_vm._s(_vm.message.content))]),_c('div',{staticClass:"time-row"},[_c('span',{staticClass:"time-text"},[_vm._v(_vm._s(_vm.formatTime(_vm.message.createdAt)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }